import client from "./client";
import anonymousClient from "./anonymousClient";

export default {
  get: async (uri, params = {}) => {
    const { data } = await client.get(uri, { params });
    return data;
  },

  getWithNoCompanyId: async (uri, params = {}) => {
    const { data } = await client.get(uri, { params, _skipCompanyId: true });
    return data;
  },

  getBinary: async uri => {
    return await client.get(uri, { responseType: "arraybuffer" });
  },

  post: async (uri, params) => {
    const { data } = await client.post(uri, params);
    return data;
  },

  postWithNoCompanyId: async (uri, params) => {
    const { data } = await client.post(uri, params, { _skipCompanyId: true });
    return data;
  },

  postWithNoReauthentication: async (uri, params) => {
    const { data } = await client.post(uri, params, { _skipCompanyId: true, _skipReauthentication: true });
    return data;
  },

  postAnonymous: async (uri, params) => {
    const { data } = await anonymousClient.post(uri, params);
    return data;
  },

  postFile: async (uri, file, fileExtraData) => {
    const formData = new FormData();
    formData.append("file", file);
    if (fileExtraData)
      Object.keys(fileExtraData).forEach(key => formData.append(key, JSON.stringify(fileExtraData[key])));

    const { data } = await client.post(uri, formData);
    return data;
  },

  putFile: async (uri, file, fileExtraData) => {
    const formData = new FormData();
    formData.append("file", file);
    if (fileExtraData)
      Object.keys(fileExtraData).forEach(key => formData.append(key, JSON.stringify(fileExtraData[key])));

    const { data } = await client.put(uri, formData);
    return data;
  },

  put: async (uri, params) => {
    const { data } = await client.put(uri, params);
    return data;
  },

  deleteRequest: async uri => {
    const { data } = await client.delete(uri);
    return data;
  },
};
